module.exports = __webpack_public_path__ + "static/3_section-bg-3f433ad0bdb85d1713b7f8612d015438.png";